/* eslint-disable */
import { CognitoAuth, StorageHelper } from 'amazon-cognito-auth-js';
import routes from '../routes'; 
import store from './../store';
import { Loading } from "element-ui" 



const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;
const REDIRECT_URI_SIGNOUT = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;
const APP_URL = process.env.VUE_APP_APP_URL;

var authData = { 
    ClientId : CLIENT_ID, // Your client id here
    AppWebDomain : APP_DOMAIN,
    TokenScopesArray : ['openid', 'email', 'profile'],
    RedirectUriSignIn : REDIRECT_URI,
    RedirectUriSignOut : REDIRECT_URI_SIGNOUT,  
    UserPoolId : USERPOOL_ID,
    grant_type : 'authorization_code' 
} 


var auth = new CognitoAuth(authData)
var loadingInstance = null
var is_refresh= false

auth.useCodeGrantFlow()

auth.userhandler = { 
    onSuccess: async function(result) {

        store.commit('setLoggedIn', true);
 

        try {
            const data  = await store.dispatch('getUserPerfil')
            
            // Si el usuario está inactivo, cerrar sesión inmediatamente
            if (data && data.estado === false) {
                routes.push('/logout')
                return
            }

            if(is_refresh)
            {
                loadingInstance.close()
                return is_refresh = false

            } 

            const perfil=  data.id
            console.log('perfil', perfil);

            if (perfil) {
                routes.push('/home')
            } else {
                routes.push('/logout')
            }
        } catch (error) {
         console.log("error::", error)  

        } 
    },
    onFailure: function(err) {
        // UserInfoStore.setLoggedOut();
        store.commit('setLoggedOut');

        routes.go({ path: '/error', query: { message: 'Login failed due to ' + err } });
    }
};

function getUserInfoStorageKey(){
    var keyPrefix = 'CognitoIdentityServiceProvider.' + auth.getClientId();
    var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
    var userInfoKey = keyPrefix + '.' + tokenUserName + '.userInfo';
    return userInfoKey;
}

var storageHelper = new StorageHelper();
var storage = storageHelper.getStorage();

async function refresh()
{

    if(is_refresh) return 
    
    is_refresh = true
    loadingInstance = Loading.service({ fullscreen: true, text: 'Cargando..', background: 'rgba(0, 0, 0, 0.8)' }) 

    let user = await auth.getCachedSession() 
    auth.refreshSession(user.getRefreshToken().getToken())
    
}
async function getExpiracionDiferencia()
{
    let user = await auth.getCachedSession() 
        
    const exp = user.getIdToken().payload.exp  

    const actual = (new Date()).getTime() /1000

    const diferencia = Math.round(exp-actual) 
    
    return diferencia

}


async function calcula_expiracion()
{ 
    try {
        let user = await auth.getCachedSession() 
        
        const exp = user.getIdToken().payload.exp  

        const actual = (new Date()).getTime() /1000
    
        const diferencia = Math.round(exp-actual)

        const limit = (55*60)

        if(limit > diferencia) 
        {
            await this.refresh()
        }

    } catch (error) {
        console.log("error:: ", error)
    }

}


export default{
    getExpiracionDiferencia,
    calcula_expiracion,
    refresh,
    auth: auth,
    login(){
        auth.getSession();
    },
    logout(){
        if (auth.isUserSignedIn()) {
            var userInfoKey = this.getUserInfoStorageKey();
            auth.signOut();

            storage.removeItem(userInfoKey);
        }
    },
    getUserInfoStorageKey,

}
